import {withStyles} from '@material-ui/core/styles';
import {Theme} from "@material-ui/core";
import * as React from 'react';
import {ComponentClass} from 'react';
import {IStore} from '../store/index';
import {connect} from 'react-redux';
import {NotificationState} from '../store/notification/notification-reducer';
import Snackbar from '@material-ui/core/Snackbar';
import {mockTheme} from '../utils/utils';
import Fade from '@material-ui/core/Fade';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import {NotificationActions} from '../store/notification/notification-actions';
import {ClassNameMap} from '@material-ui/core/styles/withStyles';


const variantIcon = {
    success: CheckCircleIcon,
    warning: ErrorIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const styles = (theme: Theme) => ({
    container: {
        margin: theme.spacing.unit,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        fontSize: 20,
        opacity: 0.9,
        marginRight: theme.spacing.unit,
    },
    close: {
        fontSize: 20,
        opacity: 0.9,
        marginRight: theme.spacing.unit,
    },
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: red[400],
    },
    info: {
        backgroundColor: orange[600],
    },
    warning: {
        backgroundColor: amber[700],
    },
});

const classesType = styles(mockTheme);

interface SnackbarHandlerProps {
    actions: NotificationActions,
    classes: ClassNameMap<keyof typeof classesType>,
    notification?: NotificationState
}

class SnackbarHandler extends React.Component<SnackbarHandlerProps, { open: boolean, transition: React.ComponentType }> {

    constructor(props: any) {
        super(props);

        this.close = this.close.bind(this);
        this.state = {
            open: false,
            // transition: (tprops: any) => (<Slide {...tprops} direction="down"/>)
            transition: Fade
        };

    }

    close() {
        this.props.actions.hide();
    }

    componentWillReceiveProps(nextProps: any, nextCtx: any) {
        console.log(nextProps, nextCtx);
    }

    render() {
        const state: NotificationState = this.props.notification || {visible: false};
        let title = (state.data && state.data.title) || '';
        const message = (state.data && state.data.message) || '';
        const classes = this.props.classes || {} as any;
        const type = state.data && state.data.type || 'success';

        if (title && message) {
            title += ': ';

        }

        const LeftIcon = variantIcon[type];


        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                className={classes.container}
                open={state.visible}
                TransitionComponent={this.state.transition}
            >
                <SnackbarContent
                    className={classes[type]}
                    message={
                        <span className={classes[type]}>
                          <LeftIcon className={classes.icon}/>
                            <b>{title}</b> {message}
                        </span>
                    }
                />
            </Snackbar>
        );
    }
}


function mapStateToProps(state: IStore, ownProps: SnackbarHandlerProps) {
    return {
        notification: state.notification,
        ...ownProps
    };
}


const styled = withStyles(styles)(SnackbarHandler);
const connected = connect(mapStateToProps, {})(styled);

export default connected as ComponentClass<Partial<SnackbarHandlerProps>>;



// WEBPACK FOOTER //
// ./src/components/snackbar.tsx